/* Herbal Gul — Premium Theme JS */
(function () {
  'use strict';

  /* ---------- Scroll progress bar ---------- */
  var progress = document.querySelector('[data-scroll-progress]');
  if (progress) {
    var onScrollProgress = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      progress.style.width = max > 0 ? (h.scrollTop / max) * 100 + '%' : '0%';
    };
    window.addEventListener('scroll', onScrollProgress, { passive: true });
    onScrollProgress();
  }

  /* ---------- Header scrolled state ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScrollHeader = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
      toggle.classList.toggle('is-open');
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Animated counters ---------- */
  var counters = document.querySelectorAll('[data-counter]');
  if ('IntersectionObserver' in window && counters.length) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        counterObserver.unobserve(el);
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var duration = 1600;
        var start = performance.now();
        var step = function (now) {
          var t = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(target * eased).toLocaleString('en-PK');
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  /* ---------- Testimonials carousel ---------- */
  var carousel = document.querySelector('[data-carousel]');
  if (carousel) {
    var prev = document.querySelector('[data-carousel-prev]');
    var next = document.querySelector('[data-carousel-next]');
    var scrollAmount = function () {
      var card = carousel.querySelector('.testimonial');
      return card ? card.offsetWidth + 22 : 320;
    };
    if (prev) prev.addEventListener('click', function () { carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  }

  /* ---------- Product gallery thumbnails ---------- */
  var mainImage = document.getElementById('MainProductImage');
  if (mainImage) {
    document.querySelectorAll('.main-product__thumbs .thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-image');
        document.querySelectorAll('.main-product__thumbs .thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Money formatter (PKR) ---------- */
  var formatMoney = function (cents) {
    return 'Rs.' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
  };

  /* ---------- Cart count updater ---------- */
  var updateCartCount = function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.add('cart-count--pulse');
          setTimeout(function () { el.classList.remove('cart-count--pulse'); }, 600);
        });
      });
  };

  /* ---------- AJAX add to cart ---------- */
  var ajaxAdd = function (variantId, quantity, button) {
    if (!variantId) return;
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        updateCartCount();
        if (button) { button.textContent = '✓ Added'; }
        setTimeout(function () {
          if (button) { button.disabled = false; button.textContent = original; }
        }, 1400);
      })
      .catch(function () {
        if (button) { button.disabled = false; button.textContent = original; }
        window.location.href = '/cart';
      });
  };

  /* ---------- Quick add on product cards ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    e.stopPropagation();
    ajaxAdd(qa.getAttribute('data-quick-add'), 1, qa);
  });

  /* ---------- Variant selection ---------- */
  var form = document.getElementById('ProductForm');
  if (form) {
    var variantsScript = form.querySelector('[data-variants-json]');
    var variantInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-button]');
    var priceEl = document.getElementById('ProductPrice');
    var selects = form.querySelectorAll('[data-option-select]');

    if (variantsScript && selects.length) {
      var variants = JSON.parse(variantsScript.textContent);
      var onChange = function () {
        var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        });
        if (match) {
          variantInput.value = match.id;
          if (priceEl) {
            var html = '';
            if (match.compare_at_price && match.compare_at_price > match.price) {
              html += '<s>' + formatMoney(match.compare_at_price) + '</s> ';
              html += '<span class="price--sale">' + formatMoney(match.price) + '</span>';
            } else {
              html += '<span>' + formatMoney(match.price) + '</span>';
            }
            priceEl.innerHTML = html;
          }
          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
          if (addButton) {
            addButton.disabled = !match.available;
            addButton.textContent = match.available ? 'Add to cart' : 'Sold out';
          }
        } else if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
      };
      selects.forEach(function (s) { s.addEventListener('change', onChange); });
    }
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  if (stickyBar && form) {
    var buyRow = form.querySelector('.product-buy-row');
    var stickyAdd = stickyBar.querySelector('[data-sticky-add]');
    if ('IntersectionObserver' in window && buyRow) {
      var atcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      atcObserver.observe(buyRow);
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var vi = form.querySelector('[data-variant-id]');
        var qty = form.querySelector('input[name="quantity"]');
        ajaxAdd(vi ? vi.value : null, qty ? parseInt(qty.value, 10) : 1, stickyAdd);
      });
    }
  }
})();
